const BASE = '/muzon/api';

function getToken() { return localStorage.getItem('djapp_token'); }
function getRole()  { return localStorage.getItem('djapp_role'); }
function getRoomCode() { return localStorage.getItem('djapp_room_code'); }
function getRoomName() { return localStorage.getItem('djapp_room_name'); }

function saveSession(token, role, roomCode, roomName) {
  localStorage.setItem('djapp_token', token);
  localStorage.setItem('djapp_role', role);
  if (roomCode) localStorage.setItem('djapp_room_code', roomCode);
  else localStorage.removeItem('djapp_room_code');
  if (roomName) localStorage.setItem('djapp_room_name', roomName);
  else localStorage.removeItem('djapp_room_name');
}

function clearSession() {
  ['djapp_token','djapp_role','djapp_room_code','djapp_room_name'].forEach(k => localStorage.removeItem(k));
}

function authHeaders() {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function request(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: 'Ошибка запроса' }));
    throw new Error(err.message || 'Ошибка запроса');
  }
  const text = await res.text();
  return text ? JSON.parse(text) : null;
}

export const api = {
  // Auth
  adminLogin: (username, password) =>
    request('POST', '/auth/admin/login', { username, password }),
  djLogin: (djCode) =>
    request('POST', '/auth/dj/login', { djCode }),
  saveSession,
  clearSession,
  getToken,
  getRole,
  getRoomCode,
  getRoomName,
  isAdmin: () => getRole() === 'ADMIN',
  isDj:    () => getRole() === 'DJ',

  // Rooms (public)
  getRoom: (code) => request('GET', `/rooms/${code}`),
  getRoomSongs: (code) => request('GET', `/rooms/${code}/songs`),

  // Songs (guest)
  addSong:    (code, title) => request('POST',   `/rooms/${code}/songs`, { title }),
  deleteSong: (code, id)    => request('DELETE',  `/rooms/${code}/songs/${id}`),
  toggleLike: (code, id)    => request('POST',    `/rooms/${code}/songs/${id}/like`),

  // DJ portal
  djGetRoom:       ()    => request('GET',    '/dj/room'),
  djGetSongs:      ()    => request('GET',    '/dj/room/songs'),
  djDeleteSong:    (id)  => request('DELETE',  `/dj/songs/${id}`),
  djMarkPlayed:    (id)  => request('POST',    `/dj/songs/${id}/played`),
  djUnmarkPlayed:  (id)  => request('DELETE',  `/dj/songs/${id}/played`),

  // Admin portal
  adminListRooms:  ()     => request('GET',    '/admin/rooms'),
  adminCreateRoom: (name) => request('POST',   '/admin/rooms', { name }),
  adminDeleteRoom: (id)   => request('DELETE',  `/admin/rooms/${id}`),
};
